"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-background py-16 px-6 sm:py-24">
      <div className={`mx-auto max-w-3xl text-center transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <h2 className="font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
          Ready to Build with Confidence?
        </h2>
        <p className="mt-6 text-base leading-relaxed text-foreground/80 sm:text-lg">
          If you're thinking about a custom home in Central Maine, let's talk through your vision. No pressure, no quotes—just a thoughtful conversation about what you're building and how we might work together.
        </p>
        <div className="mt-10">
          <Link to="/ContactPage">
            <Button size="lg" className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:bg-primary/110 focus-ring">
              Start a Conversation
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}